import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid } from '@mui/material';

import { BuildingTree, Loading } from 'components';
import { ROUTES } from 'consts';
import { footerZIndex } from 'configs';
import { useParamValues } from 'hooks/url.hook';
import { useFetchBuildingQuery } from 'store/apis';
import { useAppDispatch, useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { updateLayout } from 'store/slices/layout.slice';
import { DashboardPageContextProvider } from './dashboard-page.context';
import { DashboardMetricCards } from './dashboard-metric-cards';
import { VisualizationProvider } from './visualization.context';

interface DashboardPageProps {}

export const DashboardPage: React.FC<DashboardPageProps> = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { buildingId: buildingIdStr } = useParamValues(['buildingId']);
  const buildingId = buildingIdStr ? Number(buildingIdStr) : null;

  const { data: building, isLoading: loading_building } = useFetchBuildingQuery({ orgSlug, id: buildingId as number });

  React.useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Dashboard' }));
  }, []);

  React.useEffect(() => {
    if (!loading_building && !building) {
      navigate(`/${orgSlug}/${ROUTES.DASHBOARD}`);
    }
  }, [building, loading_building]);

  if (loading_building) {
    return <Loading text="Building dashboard configuration..." height={400} />;
  }

  return buildingId ? (
    <DashboardPageContextProvider>
      <Grid container rowSpacing={5} columnSpacing={3}>
        <Grid item xs={12} md={6} lg={5} xl={3}>
          <VisualizationProvider buildingId={buildingId}>
            <BuildingTree />
          </VisualizationProvider>
        </Grid>

        <Grid item xs={12} md={6} lg={7} xl={9}>
          <Box sx={{ position: 'sticky', top: 90, zIndex: footerZIndex - 10 }}>
            <DashboardMetricCards />
          </Box>
        </Grid>
      </Grid>
    </DashboardPageContextProvider>
  ) : null;
};
